webpackJsonp([40],{

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(52)(
  /* script */
  __webpack_require__(787),
  /* template */
  __webpack_require__(816),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 787:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      max25chars: function max25chars(v) {
        return v.length <= 25 || 'Input too long!';
      },
      pagination: {},
      headers: [{
        text: 'Dessert (100g serving)',
        align: 'left',
        sortable: false,
        value: 'name'
      }, { text: 'Calories', value: 'calories' }, { text: 'Fat (g)', value: 'fat' }, { text: 'Carbs (g)', value: 'carbs' }, { text: 'Protein (g)', value: 'protein' }, { text: 'Iron (%)', value: 'iron' }],
      desserts: [{
        value: false,
        name: 'Frozen Yogurt',
        calories: 159,
        fat: 6.0,
        carbs: 24,
        protein: 4.0,
        iron: '1%'
      }, {
        value: false,
        name: 'Ice cream sandwich',
        calories: 237,
        fat: 9.0,
        carbs: 37,
        protein: 4.3,
        iron: '1%'
      }, {
        value: false,
        name: 'Eclair',
        calories: 262,
        fat: 16.0,
        carbs: 23,
        protein: 6.0,
        iron: '7%'
      }, {
        value: false,
        name: 'Cupcake',
        calories: 305,
        fat: 3.7,
        carbs: 67,
        protein: 4.3,
        iron: '8%'
      }, {
        value: false,
        name: 'Gingerbread',
        calories: 356,
        fat: 16.0,
        carbs: 49,
        protein: 3.9,
        iron: '16%'
      }, {
        value: false,
        name: 'Jelly bean',
        calories: 375,
        fat: 0.0,
        carbs: 94,
        protein: 0.0,
        iron: '0%'
      }, {
        value: false,
        name: 'Lollipop',
        calories: 392,
        fat: 0.2,
        carbs: 98,
        protein: 0,
        iron: '2%'
      }, {
        value: false,
        name: 'Honeycomb',
        calories: 408,
        fat: 3.2,
        carbs: 87,
        protein: 6.5,
        iron: '45%'
      }, {
        value: false,
        name: 'Donut',
        calories: 452,
        fat: 25.0,
        carbs: 51,
        protein: 4.9,
        iron: '22%'
      }, {
        value: false,
        name: 'KitKat',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%'
      }]
    };
  }
});

/***/ }),

/***/ 816:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.desserts
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.name,
            "lazy": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "name", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "name", $event)
            }
          }
        }, [_vm._v(" " + _vm._s(props.item.name) + "\n        "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "rules": [_vm.max25chars],
            "label": "Edit",
            "single-line": "",
            "counter": ""
          },
          slot: "input",
          model: {
            value: (props.item.name),
            callback: function($$v) {
              _vm.$set(props.item, "name", $$v)
            },
            expression: "props.item.name"
          }
        })], 1)], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.calories))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.fat))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.carbs))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.protein))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.iron,
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "iron", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "iron", $event)
            }
          }
        }, [_c('div', [_vm._v(_vm._s(props.item.iron))]), _vm._v(" "), _c('div', {
          staticClass: "mt-3 title",
          attrs: {
            "slot": "input"
          },
          slot: "input"
        }, [_vm._v("Update Iron")]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "rules": [_vm.max25chars],
            "label": "Edit",
            "single-line": "",
            "counter": "",
            "autofocus": ""
          },
          slot: "input",
          model: {
            value: (props.item.iron),
            callback: function($$v) {
              _vm.$set(props.item, "iron", $$v)
            },
            expression: "props.item.iron"
          }
        })], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n    From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\n  ")]
      }
    }])
  })
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/40.77081c5b2251233560c2.js